import React, { useEffect, useState } from "react";
import { BaseUrlApi, ErrorMessage } from "../../../../../../lib/api";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { LevelCard } from "./LevelCard";
import { toast } from "sonner";

export default function LevelStep({
  course,
  selectedLevel,
  handleLevelSelect,
}) {
  return (
    <section className="mb-16">
      <h2 className="text-2xl font-bold mb-6">Select your level</h2>
      {!course?.levels?.length ? (
        <div className="text-center p-12 border rounded-lg">
          <h3 className="text-lg font-medium">
            No Levels available for this course
          </h3>
          <p className="text-muted-foreground mt-2">
            Please try another course
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {course?.levels?.map((level) => (
            <LevelCard
              key={level.id}
              level={level}
              isSelected={selectedLevel?.id === level.id}
              onSelect={() => handleLevelSelect(level)}
            />
          ))}
        </div>
      )}
    </section>
  );
}
